// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2apkY","container":"styles_container__UFZL4","input__container":"styles_input__container__1qZjO","search__icon":"styles_search__icon__1EoeI"};